export const LIST_CHECKOUT_CONFIG = 'LIST_CHECKOUT_CONFIG';
export const CREATE_CHECKOUT_CONFIG = 'CREATE_CHECKOUT_CONFIG';
export const UPDATE_CHECKOUT_CONFIG = 'UPDATE_CHECKOUT_CONFIG';
export const DELETE_CHECKOUT_CONFIG = 'DELETE_CHECKOUT_CONFIG';
export const MARK_DEFAULT_CHECKOUT_CONFIG = 'MARK_DEFAULT_CHECKOUT_CONFIG';
export const GET_CHECKOUT_CONFIG = 'GET_CHECKOUT_CONFIG';
